import React, { useContext, useEffect } from 'react'
import { Box } from '@mui/material'
import { KeDoContext } from '../kedo-context'
import { useHistory, useLocation } from 'react-router-dom'

const AzureConnect: React.FC = () => {
    const kedo = useContext(KeDoContext)
    const history = useHistory()
    const location = useLocation()

    useEffect(() => {
        const params = new URLSearchParams(location.search)

        if (params.has('username')) {
            const tokenData = {
                username: params.get('username'),
                iat: params.get('iat'),
                exp: params.get('exp'),
                user_id: parseInt(params.get('id') || '0'),
                roles: (params.get('roles') || '').split(','),
            }

            kedo.user().updateInfoFromJWTToken(tokenData)
            localStorage.setItem('tokenData', JSON.stringify(tokenData))

            const referer = localStorage.getItem('referer')
            localStorage.removeItem('referer')

            if (referer && referer !== '/') {
                history.push(referer)
            } else {
                history.push('/environment')
            }
        } else {
            history.push('/')
        }
    }, [kedo, history, location.search])

    return <Box display="flex" justifyContent="center" />
}

export default AzureConnect
